import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PrepareDataTable from "./PrepareDataTable";
import { AccountListContainer, Title } from "./BankAccountList.styled";
import AddEditBankAccount from "../AddEditBankAccount";

import "./BankAccountList.scss";

/**
 * Site List,
 * Path - /administration/finance
 * @see See [https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3592617985/Administration+-+Bank+accounts)
 * @component
 */
const BankAccountList = (props) => {
  const { t, columnList, countries } = props;

  const [isAddAccountPopupVisible, setAddAccountPopupVisible] = useState(false);
  const [isRefreshList, setIsRefreshList] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const createNewAccount = () => {
    setAddAccountPopupVisible(true);
  };
  const closeAccountCreationPopup = () => {
    setAddAccountPopupVisible(false);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <AccountListContainer className="bankAccount-list">
      <Title>{t("BANK_ACCOUNTS")}</Title>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        columnList={columnList}
        updateRefeshStatus={updateRefeshStatus}
        createNewAccount={createNewAccount}
        countries={countries}
      />
      {isAddAccountPopupVisible && (
        <AddEditBankAccount
          title={t("BANK_ACCOUNT_NEW")}
          onClose={closeAccountCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </AccountListContainer>
  );
};

BankAccountList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
};

BankAccountList.defaultProps = {
  columnList: [],
};

export default withTranslation()(BankAccountList);
